import { render, staticRenderFns } from "./DisplayGroups.vue?vue&type=template&id=eeb96656&scoped=true&"
import script from "./DisplayGroups.vue?vue&type=script&lang=js&"
export * from "./DisplayGroups.vue?vue&type=script&lang=js&"
import style0 from "./DisplayGroups.vue?vue&type=style&index=0&id=eeb96656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb96656",
  null
  
)

export default component.exports